<template>
  <q-fab-action
      v-bind="$attrs"
      external-label
      label-position="left"
      label-class="bg-neutral-80 text-white"
      color="primary"
      :icon="icon"
      :label="label"
  />
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>
